import { NgModule } from '@angular/core';

import { NumberSpinnerComponent } from './number-spinner.component';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

@NgModule({
  imports: [CommonModule, FormsModule, TranslateModule, SvgIconModule],
  declarations: [NumberSpinnerComponent],
  providers: [],
  exports: [NumberSpinnerComponent]
})
export class NumberSpinnerModule {
}
